import { Link } from "react-router-dom";
import { Dialog, Heading, Text } from "@rshbintech.dboul/core-ui";
import { BellPoint as BellPointImage } from "@rshbintech.dboul/images";
import { useAppTranslation } from "../../../../../hooks";
import { NotificationDetailsProps, DefaultNotificationData } from "./types";
import styles from "./styles.scss";

const defaultNotificationData: DefaultNotificationData = {
  body: "",
  linkName: "",
  linkUrl: "",
  date: "",
  isImportant: false,
  subject: "",
};

export const NotificationDetails = ({
  isOpened,
  onClose,
  notificationData,
}: NotificationDetailsProps) => {
  const { translate } = useAppTranslation("NOTIFICATION");
  const { body, linkName, linkUrl, date, isImportant, subject } =
    notificationData ?? defaultNotificationData;

  /* Разделение текста уведомления на 2 части для подмены части текста на ссылку, ведущую к документу. 
     Если номер документа, совпадающий с названием ссылки с бэка, повторяется больше 2 раз, 
     то будет отображаться кнопка-ссылка Подробнее */
  const separatedBodyText = body.split(linkName);

  // Текст уведомления с ссылкой внутри
  const bodyTextWithLink = (
    <Text className={styles.body}>
      {separatedBodyText[0]}
      <Link to={linkUrl} className={styles["body-link"]}>
        {linkName}
      </Link>
      {separatedBodyText[1]}
    </Text>
  );

  // Текст уведомления с ссылкой кнопкой Подробнее
  const bodyTextWithDetailsButton = (
    <Text className={styles.body}>
      {body}
      <Link to={linkUrl} className={styles["body-link"]}>
        {translate("DETAILS_BUTTON_LINK_TEXT")}
      </Link>
    </Text>
  );

  // Текст уведомления без ссылки
  const bodyText = <Text className={styles.body}>{body}</Text>;

  const linkInBodyTextDisplay =
    linkName && linkUrl && separatedBodyText.length === 2;

  const linkInDetailsButtonDisplay =
    (!linkName && linkUrl) || separatedBodyText.length > 2;

  const linkInButtonContent = linkInDetailsButtonDisplay
    ? bodyTextWithDetailsButton
    : bodyText;

  const bodyTextContent = linkInBodyTextDisplay
    ? bodyTextWithLink
    : linkInButtonContent;

  return (
    <Dialog
      className={styles.dialog}
      onClose={onClose}
      opened={isOpened}
      size="medium"
    >
      <div className={styles.content}>
        <BellPointImage className={styles.image} />
        {isImportant && (
          <Text className={styles["important-mark"]}>
            {translate("IMPORTANT_MARK_TEXT")}
          </Text>
        )}
        <Heading level={4} className={styles.subject}>
          {subject}
        </Heading>
        {bodyTextContent}
        <Text className={styles.date}>{date}</Text>
      </div>
    </Dialog>
  );
};
